import {Dialog, FileCard, FileUploader, MimeType, Pane, TextareaField, toaster} from "evergreen-ui";
import React from "react";
import {addNewVersion} from "../Api";

export default function UploadNewVersionDialog({materialsId, isShown, setIsShown, onVersionUpdatedAction}) {

    const acceptedMimeTypes = [MimeType.doc, MimeType.docx, MimeType.xls, MimeType.xlsx, MimeType.pdf, MimeType.rtf]

    const [notes, setNotes] = React.useState("")
    const [file, setFile] = React.useState([])

    const [fileRejections, setFileRejections] = React.useState([])
    const handleChange = React.useCallback((files) => {
        setFile([files[0]])
    }, [])
    const handleRejected = React.useCallback((fileRejections) => setFileRejections([fileRejections[0]]), [])
    const handleRemove = React.useCallback(() => {
        setFile([])
        setFileRejections([])
    }, [])


    function onUploadNewVersion() {
        addNewVersion(file[0], notes, materialsId).then(
            res => {
                toaster.success("Новая версия была успешно загружена!")
                onVersionUpdatedAction()
            }
        )
    }

    function getErrorMessage(file) {
        if (!acceptedMimeTypes.includes(file.type)) {
            return "Данный формат файла не поддерживается. Доступна загрузка файлов следующего формата: doc, docx, xls, " +
                "xlsx, pdf, rtf";
        }

        if (file.size > (process.env.REACT_APP_MATERIALS_FILE_SIZE_MB * 1024 ** 2)) {
            return "Размер загружаемого файла не должен превышать " + process.env.REACT_APP_MATERIALS_FILE_SIZE_MB + "Мб."
        }
    }

    return (
        <Dialog
            shouldCloseOnOverlayClick={false}
            shouldCloseOnEscapePress={false}
            width={400}
            isShown={isShown}
            onCancel={() => setIsShown(false)}
            onConfirm={() => {
                onUploadNewVersion()
                setIsShown(false)
            }}
            onOpenComplete={() => {setFile(null); setNotes("")}}
            title="Загрузка новой версии"
            cancelLabel="Отмена"
            isConfirmDisabled={file == null || fileRejections.length > 0 || file.length === 0}
            confirmLabel="Сохранить"
        >
            <Pane>
                <TextareaField
                    value={notes}
                    onChange={(e) => setNotes(e.target.value)}
                    description="Заметки"
                    marginBottom={5}
                    placeholder="Введите заметки о загружаемой версии"
                />

                <FileUploader
                    acceptedMimeTypes={acceptedMimeTypes}
                    label="Загрузите файл"
                    description={"Вы можете загрузить только 1 файл размером не более " + process.env.REACT_APP_MATERIALS_FILE_SIZE_MB + "Мб. "}
                    maxSizeInBytes={process.env.REACT_APP_MATERIALS_FILE_SIZE_MB * 1024 ** 2}
                    height={100}
                    maxFiles={1}
                    onChange={handleChange}
                    onRejected={handleRejected}
                    renderFile={(file) => {
                        const { name, size, type } = file
                        const fileRejection = fileRejections.find((fileRejection) => fileRejection.file === file)
                        const { message } = fileRejection || {}
                        return (
                            <FileCard
                                key={name}
                                isInvalid={fileRejection != null}
                                name={name}
                                description={"загруженный файл"}
                                onRemove={handleRemove}
                                sizeInBytes={size}
                                type={type}
                                validationMessage={message === undefined ? "" : getErrorMessage(file) }
                            />
                        )
                    }}
                    values={file}
                />
            </Pane>
        </Dialog>
    )
}